import { appSettings } from "core/config";

export const assetUrl = (path: string) => {
    return appSettings.assetsUrl + path;
}

export const imageUrl = (path: string) => {
    return assetUrl("img/" + path);
}
